import { render, staticRenderFns } from "./tagItem.vue?vue&type=template&id=5b9507ca&scoped=true&"
import script from "./tagItem.vue?vue&type=script&lang=js&"
export * from "./tagItem.vue?vue&type=script&lang=js&"
import style0 from "./tagItem.vue?vue&type=style&index=0&id=5b9507ca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9507ca",
  null
  
)

export default component.exports